import { useState, useEffect } from 'react';
import { Modal, Button, MultiSelect } from '@mantine/core';
import { toast } from 'react-toastify';
import { attachLicence } from '../../apis/axios';

const AttachDevicesModal = ({ open, onClose, devices, selectedLicense, onAttached, }) => {
  const [selectedDevices, setSelectedDevices] = useState([]);

  useEffect(() => {
    if (selectedLicense?.devices_assigned) {
      setSelectedDevices(selectedLicense.devices_assigned.map(d => d.id));
    } else {
      setSelectedDevices([]);
    }
  }, [selectedLicense]);

  const handleAttachDevices = async () => {
    if (!selectedLicense) return;

    // Always send as array, even for single selection
    const devicesToSend = Array.isArray(selectedDevices) ? selectedDevices : [selectedDevices];

    try {
      await attachLicence({
        licence_id: selectedLicense.id,
        devices_id: devicesToSend,
      });
      toast.success('Devices attached successfully!');
      onAttached(selectedLicense.id, devicesToSend); // Update parent state
      onClose();
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || 'Failed to attach devices.');
    }
  };

  const options = devices.map(d => ({ value: d.id, label: d.name }));

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={`Attach Devices to License`}
      size="lg" // Large modal width
      styles={{
        modal: {
          maxHeight: '90vh', // Allow modal to grow up to 90% of viewport
          overflow: 'visible', // Let dropdown extend outside modal
        },
        body: {
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        },
      }}
      overflow="outside" // Mantine v6+ option to allow dropdown overflow
    >
      <MultiSelect
        data={options}
        value={selectedDevices}
        onChange={setSelectedDevices}
        placeholder="Select Devices"
        searchable
        nothingFound="No devices"
        clearable
        withinPortal // Ensures dropdown is not cut off by modal
        maxSelectedValues={selectedLicense?.type === 'single_device' ? 1 : undefined} // Single device check
      />
      <Button color="orange" onClick={handleAttachDevices}>
        Attach Devices
      </Button>
    </Modal>
  );
};

export default AttachDevicesModal;
